import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon---icon-bg-unboxed",
  "use": "icon---icon-bg-unboxed-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon---icon-bg-unboxed\">\n    <title>icons/--icon-bg-unboxed</title>\n    <g id=\"icon---icon-bg-unboxed_icons/--icon-bg-unboxed\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <rect id=\"icon---icon-bg-unboxed_Rectangle\" x=\"0\" y=\"0\" width=\"24\" height=\"24\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol